import React, { Component } from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import Home from '../components/Home';
import Secondary from '../components/Secondary';
import Contact from '../components/Contact';
import PageNotFound from '../components/PageNotFound';

class AppRouter extends Component {
	render() {
		return (
			<BrowserRouter>
				<Switch>
					<Route exact path='/' component={Home} />
					<Route path='/musicVideos' component={Secondary} />
					<Route path='/contact' component={Contact} />
					<Route component={PageNotFound} />
				</Switch>
			</BrowserRouter>
		);
	}
}

export default AppRouter;


// WEBPACK FOOTER //
// ./src/routes/AppRouter.js